import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '@/Config/api/queryKey';
import { WhatsAppSetupStatusResponse } from '@/Domain/api/WhatsAppPhoneNumbers/WhatsAppPhoneNumbers.api';

// status/ makes live Meta Graph calls for connected accounts; cache it so the Inbox path doesn't re-ping Meta on every navigation.
const STATUS_STALE_TIME = 5 * 60 * 1000;

export const useWhatsAppSetupStatus = (enabled: boolean = true) =>
  useQuery<WhatsAppSetupStatusResponse>({
    queryKey: [QueryKey.whatsappPhoneNumbers.status],
    staleTime: STATUS_STALE_TIME,
    enabled,
  });
